<script lang="ts">
	import type { CallToActionBlock } from '$models/Block/CallToActionBlock';

	export let block: CallToActionBlock;
</script>

<div class="cta">
	{#if block?.ctaTitle}
		<h2 class="cta-title">
			{@html block.ctaTitle}
		</h2>
	{/if}
	{#if block?.ctaText}
		<div class="cta-text">
			{@html block.ctaText}
		</div>
	{/if}
	{#if block?.button && block.button.title}
		<div class="cta-button">
			<a href={block.button.url} class="button button--{block.buttonClass}">
				{block.button.title}
			</a>
		</div>
	{/if}
</div>

<style lang="postcss" global>
	.cta {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		max-width: var(--container-small);
		margin: 0 auto;

		&-title {
			margin-bottom: var(--spacing-4);
		}

		&-text {
			&:not(:last-child) {
				margin-bottom: var(--spacing-6);
			}

			.button {
				display: block;

				@media (--sm) {
					display: inline-block;
					margin: 0 var(--spacing-1);
				}

				+ .button {
					margin-top: var(--spacing-4);

					@media (--sm) {
						margin-top: 0;
					}
				}
			}
		}
	}
</style>
